import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaUpload } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import UploadButton from '../../components/UploadButton';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoImportarKpi({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({
        empresa: empresa,
        nomeEmpresa: nomeEmpresa
    });
    const history = useHistory();

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Importar Planilha KPI</h1></div>
                    <div className="fin-pp__actions"></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <UploadButton
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"eventoImportarKpi"}
                        title="Selecionar Arquivo"
                        beforeSend={() => {
                            toast.info('Aguarde, isso pode levar alguns minutos');
                        }}
                        callBack={(data) => {
                            if (data.result === "sucesso") {
                                toast.success('Importação finalizada');
                                history.push("/evento");
                            } else {
                                toast.error(data.message || data.error || "Erro desconhecido");
                            }
                        }}
                        dados={{
                            empresa: empresa
                        }}
                    >Selecionar Arquivo</UploadButton>
                </div>
            </div>
        </ErpTemplate>
    );
}
